import Breadcrumb from "../../Component/Breadcrumb";

function Curriculum() {
  return (
    <>
      <Breadcrumb>Academics / Curriculum</Breadcrumb>
      <div className="innersec vision_mission">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Curriculum</h1>
            </div>

            <div className="col-lg-12">
              <img src="/Images/coming-soon.png" className="coming_soon" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Curriculum;
